import React from 'react';
import '../styles/ServiceSection-css/Images.css'; 

// Import your images
import cleaning from '../../assets/images/cleaning.jpg';
import plumber from '../../assets/images/plumbrservice.png';
import maid from '../../assets/images/classiccleaning.png';
// import acRepair from '../../assets/images/acrepair.jpg';

const Images = () => {
  return (
    <div className="hero-image-grid">
        <img src={plumber} alt="Plumbing service" className="hero-img hero-img-large" />
      <img src={cleaning} alt="Cleaning service" className="hero-img hero-img-small" />
      <img src={maid} alt="Maid service" className="hero-img hero-img-small" />
      {/* <img src={acRepair} alt="AC repair service" className="hero-img hero-img-medium" /> */}
    </div>
  );
};

export default Images;
